module.exports = __webpack_public_path__ + "static/media/Tab.e3cf63a2.less";


//////////////////
// WEBPACK FOOTER
// ./src/tabs/Tab.less
// module id = 1006
// module chunks = 0